import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TemplateService } from 'src/app/services/template.service';
import { DatePipe } from '@angular/common';
import { EventiService } from 'src/app/services/eventi.service';
import { environment } from 'src/environments/environment';
import { AlertsCenterService } from 'src/app/core/services/alerts-center.service';

@Component({
  selector: 'app-upload-protocollo-regionale',
  templateUrl: './upload-protocollo-regionale.component.html',
  styleUrls: ['./upload-protocollo-regionale.component.css']
})
export class UploadProtocolloRegionaleComponent implements OnInit, OnDestroy {

  fileName = '';
  fileSize = '';
  fileType = '';
  uploadProgress = 0;
  isLoading: Boolean = false;
  isCompleted: Boolean = false;
  nomeEvento: string = "";
  idEvento: number = 0;
  idEnte: number = 0;
  idInvio: number = 0;
  acl: String;
  isError: Boolean;
  uploadCompletedWithoutErrors: Boolean = false;
  fileUploaded: File;

  constructor(public dialogRef: MatDialogRef<UploadProtocolloRegionaleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModelEventiCalamitosi.DialogData,
    public datePipe: DatePipe,
    private alertsCenterService: AlertsCenterService, 
    private http: HttpClient) {
  }

  ngOnInit(): void {
    this.acl = sessionStorage.getItem("acl");
    this.nomeEvento = this.data.descrizione;
    this.idEvento = this.data.idEvento;
    this.idEnte = this.data.idEnte;
    this.idInvio = this.data.idInvio;
    //this.idAllegato = this.data.idAllegato;
  }

  ngOnDestroy(): void {
    window.location.reload();
  }

  sendToProtocol() {
    // console.log("Invio GET con parametro idInvio =", idInvio);

    this.isError = false;
    this.isLoading = true;
    this.uploadProgress = 0;

    this.http.get(`${environment.urls.base}/proto/protocolla`, {
      params: { idinvio: this.idInvio.toString() }
    })
    .subscribe(data => {
      console.log(data);
      this.alertsCenterService.showAlert({ type: 'success', message: "INVIO AVVENUTO CON SUCCESSO".toLocaleLowerCase(), autoClosable: true });
      this.isCompleted = true;
      this.isLoading = false;
      this.isError = false;
    }, error => {
      console.error(error);
      this.alertsCenterService.showAlert({ type: 'danger', message: "ERRORE DURANTE L'INVIO A PROTOCOLLO, RIPROVARE".toLocaleLowerCase(), autoClosable: true });
      this.isLoading = false;
      this.isError = true;
    });
  }
}
